// extracted by css-extract-rspack-plugin
export default {"colorClickable":"rgba(92, 52, 205, 1)","loader":"loader__loader___INM9D","load":"loader__load___u863p","loaderHide":"loader__loaderHide___LMj4Q loader__loader___INM9D"};